// Backend API configuration
export const API_BASE_URL = process.env.REACT_APP_AI_API_BASE_URL || '';

// Environment-specific configuration
const config = {
  development: {
    apiBaseUrl: '',
  },
  production: {
    apiBaseUrl: process.env.REACT_APP_API_BASE_URL || '',
  },
};

// Get current environment
const env = process.env.NODE_ENV || 'development';

// Export the configuration for the current environment
export const API_CONFIG = config[env];
